import React, { useEffect, useRef, useState } from 'react';
import { useRipple } from '../hooks/useRipple';
import AdUnit from './AdUnit';
import './styles/clickEffects.css';

/* ── Market data ── */
const DATA = {
  "Kano": { avg: 820, item: "Tomatoes", trend: "up", markets: [
    { name: "Dawanau Market", lat: 12.05, lng: 8.52, items: [
      { name: "Tomatoes (basket)", min: 1500, avg: 2200, max: 3000, trend: "up" },
      { name: "Onions (bag)", min: 4000, avg: 5500, max: 7000, trend: "up" },
      { name: "Rice 50kg", min: 32000, avg: 36000, max: 40000, trend: "st" },
      { name: "Groundnut oil 5L", min: 7000, avg: 8500, max: 10000, trend: "dn" },
    ]},
    { name: "Kano Central Market", lat: 12.0, lng: 8.51, items: [
      { name: "Maize (bag)", min: 18000, avg: 22000, max: 26000, trend: "up" },
      { name: "Millet (bag)", min: 15000, avg: 18000, max: 21000, trend: "st" },
      { name: "Yam (tuber)", min: 400, avg: 600, max: 900, trend: "dn" },
    ]},
  ]},
  "Lagos": { avg: 1200, item: "Fish", trend: "up", markets: [
    { name: "Mile 12 Market", lat: 6.6, lng: 3.39, items: [
      { name: "Catfish (kg)", min: 1800, avg: 2500, max: 3200, trend: "up" },
      { name: "Tomatoes (basket)", min: 2500, avg: 3500, max: 5000, trend: "up" },
      { name: "Pepper (paint)", min: 1200, avg: 1800, max: 2400, trend: "st" },
      { name: "Vegetable oil 5L", min: 6500, avg: 8000, max: 9500, trend: "dn" },
    ]},
    { name: "Oyingbo Market", lat: 6.46, lng: 3.38, items: [
      { name: "Mackerel (crate)", min: 22000, avg: 28000, max: 35000, trend: "up" },
      { name: "Beef (kg)", min: 3500, avg: 4500, max: 5500, trend: "up" },
      { name: "Yam flour (bag)", min: 8000, avg: 10000, max: 12000, trend: "st" },
    ]},
  ]},
  "Rivers": { avg: 1100, item: "Seafood", trend: "st", markets: [
    { name: "Mile 3 Market", lat: 4.82, lng: 7.01, items: [
      { name: "Fresh fish (kg)", min: 1500, avg: 2200, max: 3000, trend: "st" },
      { name: "Smoked fish (kg)", min: 3000, avg: 4000, max: 5500, trend: "up" },
      { name: "Crayfish (cup)", min: 800, avg: 1200, max: 1600, trend: "up" },
      { name: "Palm oil 5L", min: 5000, avg: 6500, max: 8000, trend: "dn" },
    ]},
    { name: "Rumuola Market", lat: 4.85, lng: 7.02, items: [
      { name: "Plantain (bunch)", min: 1500, avg: 2500, max: 3500, trend: "dn" },
      { name: "Garri (paint)", min: 1000, avg: 1400, max: 1800, trend: "st" },
    ]},
  ]},
  "FCT": { avg: 950, item: "Vegetables", trend: "dn", markets: [
    { name: "Wuse Market", lat: 9.07, lng: 7.46, items: [
      { name: "Tomatoes (basket)", min: 2000, avg: 2800, max: 3600, trend: "dn" },
      { name: "Leafy veg (bunch)", min: 200, avg: 350, max: 500, trend: "dn" },
      { name: "Chicken (kg)", min: 2500, avg: 3200, max: 4000, trend: "up" },
      { name: "Beans (bag)", min: 40000, avg: 48000, max: 56000, trend: "st" },
    ]},
    { name: "Garki Market", lat: 9.02, lng: 7.48, items: [
      { name: "Cucumber (piece)", min: 100, avg: 200, max: 350, trend: "dn" },
      { name: "Okra (bunch)", min: 300, avg: 500, max: 700, trend: "st" },
    ]},
  ]},
  "Oyo": { avg: 780, item: "Yam", trend: "st", markets: [
    { name: "Bodija Market", lat: 7.41, lng: 3.91, items: [
      { name: "Yam (tuber)", min: 500, avg: 800, max: 1200, trend: "st" },
      { name: "Cocoyam (kg)", min: 400, avg: 600, max: 900, trend: "dn" },
      { name: "Maize (bag)", min: 16000, avg: 20000, max: 24000, trend: "up" },
    ]},
  ]},
  "Kaduna": { avg: 710, item: "Sorghum", trend: "up", markets: [
    { name: "Tudun Wada Market", lat: 10.52, lng: 7.43, items: [
      { name: "Sorghum (bag)", min: 14000, avg: 18000, max: 22000, trend: "up" },
      { name: "Millet (bag)", min: 12000, avg: 15000, max: 18000, trend: "up" },
      { name: "Groundnuts (bag)", min: 25000, avg: 30000, max: 36000, trend: "st" },
    ]},
  ]},
  "Imo": { avg: 890, item: "Palm oil", trend: "dn", markets: [
    { name: "Eke Onunwa Market", lat: 5.49, lng: 7.03, items: [
      { name: "Palm oil 25L", min: 20000, avg: 26000, max: 32000, trend: "dn" },
      { name: "Yam (tuber)", min: 500, avg: 750, max: 1000, trend: "st" },
      { name: "Stockfish (piece)", min: 1500, avg: 2200, max: 3000, trend: "up" },
    ]},
  ]},
  "Katsina": { avg: 650, item: "Millet", trend: "up", markets: [
    { name: "Katsina Main Market", lat: 12.99, lng: 7.6, items: [
      { name: "Millet (bag)", min: 13000, avg: 16500, max: 20000, trend: "up" },
      { name: "Cowpea (bag)", min: 38000, avg: 46000, max: 55000, trend: "up" },
    ]},
  ]},
  "Borno": { avg: 1050, item: "Beef", trend: "up", markets: [
    { name: "Maiduguri Market", lat: 11.85, lng: 13.16, items: [
      { name: "Beef (kg)", min: 3000, avg: 4200, max: 5800, trend: "up" },
      { name: "Dried fish (kg)", min: 2500, avg: 3500, max: 4800, trend: "up" },
    ]},
  ]},
  "Delta": { avg: 870, item: "Garri", trend: "st", markets: [
    { name: "Ogbogonogo Market", lat: 5.68, lng: 5.63, items: [
      { name: "Garri (paint)", min: 900, avg: 1300, max: 1700, trend: "st" },
      { name: "Yam (tuber)", min: 450, avg: 700, max: 1000, trend: "dn" },
      { name: "Periwinkle (cup)", min: 400, avg: 600, max: 850, trend: "up" },
    ]},
  ]},
};

const FALLBACKS = ["Abia","Adamawa","Akwa Ibom","Anambra","Bauchi","Bayelsa","Benue",
  "Cross River","Ebonyi","Edo","Ekiti","Enugu","Gombe","Jigawa","Kebbi","Kogi",
  "Kwara","Nasarawa","Niger","Ogun","Ondo","Osun","Plateau","Sokoto","Taraba","Yobe","Zamfara"];
const ITEMS = ["Rice","Beans","Yam","Maize","Tomatoes","Garri","Sorghum","Millet"];
FALLBACKS.forEach(s => {
  if (!DATA[s]) DATA[s] = {
    avg: 450 + Math.floor(Math.random() * 650),
    item: ITEMS[Math.floor(Math.random() * ITEMS.length)],
    trend: ["up","dn","st"][Math.floor(Math.random() * 3)],
    markets: [],
  };
});

const MAJORS = [
  { name: "Dawanau",  lat: 12.05, lng: 8.52,  state: "Kano" },
  { name: "Mile 12",  lat: 6.6,   lng: 3.39,  state: "Lagos" },
  { name: "Wuse",     lat: 9.07,  lng: 7.46,  state: "FCT" },
  { name: "Mile 3",   lat: 4.82,  lng: 7.01,  state: "Rivers" },
  { name: "Bodija",   lat: 7.41,  lng: 3.91,  state: "Oyo" },
];

function normName(raw) {
  if (!raw) return null;
  const map = {
    "abuja federal capital territory": "FCT",
    "federal capital territory": "FCT",
    "fct": "FCT",
    "abuja": "FCT",
    "cross river": "Cross River",
    "cross river state": "Cross River",
    "akwa ibom": "Akwa Ibom",
  };
  const l = raw.toLowerCase().trim();
  if (map[l]) return map[l];
  return Object.keys(DATA).find(k => k.toLowerCase() === l) || raw;
}

function fmt(n) { return "₦" + Number(n).toLocaleString(); }

/* ── Trend badge ── */
function TrendBadge({ t }) {
  if (t === "up") return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 2, fontSize: 10, fontWeight: 600, color: "#dc2626", background: "#fee2e2", padding: "2px 6px", borderRadius: 4 }}>
      <svg width="9" height="9" viewBox="0 0 10 10"><polyline points="2,8 5,2 8,8" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" /></svg>
      Rising
    </span>
  );
  if (t === "dn") return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 2, fontSize: 10, fontWeight: 600, color: "#2563eb", background: "#dbeafe", padding: "2px 6px", borderRadius: 4 }}>
      <svg width="9" height="9" viewBox="0 0 10 10"><polyline points="2,2 5,8 8,2" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" /></svg>
      Falling
    </span>
  );
  return <span style={{ display: "inline-flex", alignItems: "center", gap: 2, fontSize: 10, fontWeight: 600, color: "#b45309", background: "#fef3c7", padding: "2px 6px", borderRadius: 4 }}>– Stable</span>;
}

/* ── Price Boards ── */
function PriceBoards({ stateName, isLocated }) {
  if (!stateName) {
    return (
      <div style={{ padding: "14px 20px", borderTop: "1px solid rgba(148,163,184,0.18)", fontSize: 12, color: "#94a3b8", display: "flex", alignItems: "center", gap: 8 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.4 }}>
          <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Allow location access or click a state to see local prices
      </div>
    );
  }

  const s = DATA[stateName];
  if (!s) return null;

  const allItems = [];
  const seen = new Set();
  s.markets.forEach(m => {
    m.items.forEach(item => {
      if (!seen.has(item.name)) {
        seen.add(item.name);
        allItems.push({ ...item, market: m.name });
      }
    });
  });

  if (allItems.length === 0) {
    return (
      <div style={{ padding: "14px 20px", borderTop: "1px solid rgba(148,163,184,0.18)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 10 }}>
          {isLocated && (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 600, color: "#0f766e", background: "#ccfbf1", padding: "2px 8px", borderRadius: 20 }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              Your location
            </span>
          )}
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{stateName}</span>
        </div>
        <div style={{ background: "#f8fafc", borderRadius: 12, padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 4 }}>Top commodity</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>{s.item}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            <div style={{ fontSize: 11, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".06em", marginBottom: 4 }}>Market index</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#1e293b" }}>{fmt(s.avg)}</div>
          </div>
          <TrendBadge t={s.trend} />
        </div>
        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8 }}>No detailed price data yet for {stateName}.</div>
      </div>
    );
  }

  return (
    <div style={{ padding: "14px 20px", borderTop: "1px solid rgba(148,163,184,0.18)" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {isLocated && (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 600, color: "#0f766e", background: "#ccfbf1", padding: "2px 8px", borderRadius: 20 }}>
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M17.657 16.657L13.414 20.9a2 2 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
              Your location
            </span>
          )}
          <span style={{ fontSize: 13, fontWeight: 700, color: "#1e293b" }}>{stateName} Prices</span>
        </div>
        <span style={{ fontSize: 10, color: "#94a3b8" }}>{allItems.length} items tracked</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 8 }}>
        {allItems.slice(0, 6).map((item, i) => (
          <div key={i} style={{
            background: item.trend === "dn" ? "#eff6ff" : item.trend === "up" ? "#fff5f5" : "#fafaf9",
            border: `1px solid ${item.trend === "dn" ? "rgba(37,99,235,0.15)" : item.trend === "up" ? "rgba(220,38,38,0.12)" : "rgba(148,163,184,0.2)"}`,
            borderRadius: 12,
            padding: "10px 12px",
            transition: "transform 0.2s",
          }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "none"}
          >
            <div style={{ fontSize: 10, fontWeight: 600, color: "#64748b", marginBottom: 3, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{item.name}</div>
            <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", fontFamily: "var(--mono, monospace)", marginBottom: 4 }}>{fmt(item.avg)}</div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontSize: 9, color: "#94a3b8" }}>{fmt(item.min)} – {fmt(item.max)}</span>
              <TrendBadge t={item.trend} />
            </div>
          </div>
        ))}
      </div>
      {allItems.length > 6 && (
        <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 8, textAlign: "center" }}>
          +{allItems.length - 6} more items — click a market for full list
        </div>
      )}
    </div>
  );
}

/* ── Detail Panel ── */
function DetailPanel({ view, stateName, marketIdx, onBack, onReset, onSelectMarket, onPredictClick }) {
  const triggerRipple = useRipple();

  if (!view || view === "empty") {
    return (
      <div style={{ padding: "12px 20px", fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", gap: 8, borderTop: "1px solid rgba(148,163,184,0.18)" }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ opacity: 0.4 }}>
          <path d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 16l4.553 2.276A1 1 0 0021 24.382V8.618a1 1 0 00-.553-.894L15 5m0 18V5M9 7l6-2" />
        </svg>
        <span>Select a state to see local market prices</span>
      </div>
    );
  }

  const s = DATA[stateName];

  if (view === "state") {
    return (
      <div style={{ padding: "14px 20px", borderTop: "1px solid rgba(148,163,184,0.18)" }}>
        <button
          onClick={onReset}
          onPointerDown={triggerRipple}
          className="ripple-host"
          style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, color: "#64748b", cursor: "pointer", marginBottom: 10, background: "none", border: "none", padding: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
          All states
        </button>
        {s.markets.length > 0 ? (
          <>
            <div style={{ fontSize: 10, textTransform: "uppercase", letterSpacing: ".05em", color: "#94a3b8", fontWeight: 600, marginBottom: 6 }}>Markets in {stateName}</div>
            {s.markets.map((m, i) => (
              <button
                key={i}
                onClick={() => onSelectMarket(i)}
                onPointerDown={triggerRipple}
                className="ripple-host"
                style={{ width: "100%", textAlign: "left", background: "#fff", border: "1px solid rgba(148,163,184,0.22)", borderRadius: 12, padding: "10px 12px", cursor: "pointer", fontSize: 12, marginBottom: 6, display: "flex", justifyContent: "space-between", alignItems: "center", transition: "all .15s" }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "#0ea5e9"; e.currentTarget.style.background = "#f0f9ff"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(148,163,184,0.22)"; e.currentTarget.style.background = "#fff"; }}>
                <span style={{ fontWeight: 600 }}>{m.name}</span>
                <span style={{ fontSize: 10, color: "#94a3b8" }}>{m.items.length} goods ›</span>
              </button>
            ))}
          </>
        ) : (
          <div style={{ fontSize: 11, color: "#94a3b8" }}>No detailed market data yet for {stateName}.</div>
        )}
        <button
          onClick={onPredictClick}
          onPointerDown={triggerRipple}
          className="ripple-host"
          style={{ width: "100%", marginTop: 8, background: "var(--green-700, #15803d)", color: "#fff", border: "none", borderRadius: 10, padding: "8px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
          Predict prices for {stateName} →
        </button>
      </div>
    );
  }

  if (view === "market") {
    const m = s.markets[marketIdx];
    return (
      <div style={{ padding: "14px 20px", borderTop: "1px solid rgba(148,163,184,0.18)" }}>
        <button onClick={onBack} style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, color: "#64748b", cursor: "pointer", marginBottom: 10, background: "none", border: "none", padding: 0 }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6" /></svg>
          {stateName}
        </button>
        <div style={{ fontSize: 12, fontWeight: 700, color: "#1e293b", marginBottom: 10 }}>{m.name}</div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["Item", "Trend", "Min", "Avg", "Max"].map((h, i) => (
                <th key={h} style={{ fontSize: 9, textTransform: "uppercase", letterSpacing: ".05em", color: "#94a3b8", fontWeight: 500, padding: "0 0 5px", borderBottom: "0.5px solid #e2e8f0", textAlign: i === 0 ? "left" : "right" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {m.items.map((item, i) => (
              <tr key={i}>
                <td style={{ padding: "5px 0", borderBottom: "0.5px solid #f1f5f9", fontSize: 11, fontWeight: 500 }}>{item.name}</td>
                <td style={{ padding: "5px 0", borderBottom: "0.5px solid #f1f5f9", textAlign: "right" }}><TrendBadge t={item.trend} /></td>
                <td style={{ padding: "5px 0", borderBottom: "0.5px solid #f1f5f9", fontSize: 11, textAlign: "right", color: "#94a3b8" }}>{fmt(item.min)}</td>
                <td style={{ padding: "5px 0", borderBottom: "0.5px solid #f1f5f9", fontSize: 11, textAlign: "right", fontWeight: 600 }}>{fmt(item.avg)}</td>
                <td style={{ padding: "5px 0", borderBottom: "0.5px solid #f1f5f9", fontSize: 11, textAlign: "right", color: "#94a3b8" }}>{fmt(item.max)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return null;
}

/* ── Draw user pin on SVG at exact GPS coords ── */
function drawUserPin(svgEl, proj, lat, lng) {
  if (!svgEl || !proj) return;
  const d3 = window.d3;
  if (!d3) return;

  d3.select(svgEl).select(".user-pin-group").remove();

  const [px, py] = proj([lng, lat]);
  if (!px || !py || isNaN(px) || isNaN(py)) return;

  const g = d3.select(svgEl).append("g").attr("class", "user-pin-group");

  g.append("circle")
    .attr("cx", px).attr("cy", py).attr("r", 18)
    .attr("fill", "rgba(14,165,233,0.15)")
    .attr("stroke", "rgba(14,165,233,0.35)")
    .attr("stroke-width", 1.5);

  g.append("circle")
    .attr("cx", px).attr("cy", py).attr("r", 10)
    .attr("fill", "rgba(14,165,233,0.25)")
    .attr("stroke", "none");

  g.append("circle")
    .attr("cx", px).attr("cy", py).attr("r", 6)
    .attr("fill", "#0ea5e9")
    .attr("stroke", "#fff")
    .attr("stroke-width", 2.5);

  g.append("circle")
    .attr("cx", px).attr("cy", py).attr("r", 2)
    .attr("fill", "#fff");

  g.append("text")
    .attr("x", px + 14).attr("y", py + 4)
    .attr("font-size", "11")
    .attr("font-weight", "700")
    .attr("fill", "#0369a1")
    .attr("stroke", "#fff")
    .attr("stroke-width", 3)
    .attr("paint-order", "stroke")
    .text("You");
}

/* ── Main NigeriaMap Component ── */
/* FIX: onStateClick added to props — was missing, causing ESLint error */
export default function NigeriaMap({ onPredictClick, onStateClick }) {
  const svgRef = useRef(null);
  const projRef = useRef(null);
  const userCoordsRef = useRef(null);
  /* Keep a ref to onStateClick so the D3 closure (which runs once) always
     calls the latest version of the callback even if the prop changes. */
  const onStateClickRef = useRef(onStateClick);
  useEffect(() => { onStateClickRef.current = onStateClick; }, [onStateClick]);

  const triggerRipple = useRipple();

  const [locText, setLocText] = useState("Locating you...");
  const [tooltip, setTooltip] = useState(null);
  const [detailView, setDetailView] = useState("empty");
  const [selectedState, setSelectedState] = useState(null);
  const [selectedMarketIdx, setSelectedMarketIdx] = useState(null);
  const [legendItems, setLegendItems] = useState([]);
  const [locatedState, setLocatedState] = useState(null);

  useEffect(() => {
    locateUser();
  }, []);

  useEffect(() => {
    if (projRef.current && userCoordsRef.current && svgRef.current) {
      drawUserPin(svgRef.current, projRef.current, userCoordsRef.current.lat, userCoordsRef.current.lng);
    }
  });

  useEffect(() => {
    async function loadAndRender() {
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/d3/7.8.5/d3.min.js");
      await loadScript("https://cdnjs.cloudflare.com/ajax/libs/topojson/3.0.2/topojson.min.js");
      const d3 = window.d3;
      const topojson = window.topojson;

      const clr = ["#e8f4f0","#c5e8dc","#9fd9c5","#72c5ad","#45b094","#2a9a7a","#1a7f62","#0f654d","#064e3b"];
      const scale = d3.scaleQuantize([400, 1300], clr);

      try {
        const topo = await d3.json("https://cdn.jsdelivr.net/npm/datamaps@0.5.10/src/js/data/nga.topo.json");
        const features = topojson.feature(topo, topo.objects.nga).features;
        const svgEl = svgRef.current;
        if (!svgEl) return;

        const W = 640, H = 520;
        const proj = d3.geoMercator().fitSize([W, H], topojson.feature(topo, topo.objects.nga));
        projRef.current = proj;
        const pathGen = d3.geoPath(proj);

        const svg = d3.select(svgEl);
        svg.selectAll("*").remove();

        /* ── State fills ── */
        svg.selectAll(".state-path")
          .data(features)
          .join("path")
          .attr("class", "state-path")
          .attr("d", pathGen)
          .attr("fill", d => {
            const n = normName(d.properties.name || d.id);
            const s = DATA[n];
            return s ? scale(s.avg) : "#e8f4f0";
          })
          .attr("stroke", "#ffffff")
          .attr("stroke-width", 1.2)
          .style("cursor", "pointer")
          .style("transition", "fill .2s, stroke .2s, stroke-width .2s")
          .on("mousemove", function (ev, d) {
            const n = normName(d.properties.name || d.id);
            const s = DATA[n];
            if (!n) return;
            const mRect = svgEl.parentElement.getBoundingClientRect();
            const x = ev.clientX - mRect.left;
            const y = ev.clientY - mRect.top;
            setTooltip({ name: n, s, x, y, wrapW: mRect.width, wrapH: mRect.height });
            d3.select(this).attr("stroke", "#0ea5e9").attr("stroke-width", 2);
          })
          .on("mouseleave", function () {
            setTooltip(null);
            d3.select(this).attr("stroke", "#ffffff").attr("stroke-width", 1.2);
          })
          .on("click", function (ev, d) {
            const n = normName(d.properties.name || d.id);
            setTooltip(null);
            svg.selectAll(".state-path")
              .attr("stroke", "#ffffff")
              .attr("stroke-width", 1.2)
              .attr("fill", dd => {
                const nn = normName(dd.properties.name || dd.id);
                const ss = DATA[nn];
                return ss ? scale(ss.avg) : "#e8f4f0";
              });
            d3.select(this)
              .attr("stroke", "#0ea5e9")
              .attr("stroke-width", 2.4)
              .attr("fill", "#bae6fd");
            setSelectedState(n);
            setDetailView("state");
            setSelectedMarketIdx(null);
            /* Use ref so the latest callback is always called */
            if (onStateClickRef.current) onStateClickRef.current(n);
            if (userCoordsRef.current) {
              setTimeout(() => drawUserPin(svgEl, proj, userCoordsRef.current.lat, userCoordsRef.current.lng), 20);
            }
          });

        /* ── State name labels — white-stroked for readability ── */
        svg.selectAll(".state-label")
          .data(features)
          .join("text")
          .attr("class", "state-label")
          .attr("x", d => pathGen.centroid(d)[0])
          .attr("y", d => pathGen.centroid(d)[1])
          .attr("text-anchor", "middle")
          .attr("dominant-baseline", "middle")
          .attr("font-size", "7.5")
          .attr("font-weight", "700")
          .attr("fill", "#1a3a2a")
          .attr("stroke", "rgba(255,255,255,0.85)")
          .attr("stroke-width", "3")
          .attr("paint-order", "stroke")
          .attr("pointer-events", "none")
          .attr("font-family", "Syne, sans-serif")
          .attr("letter-spacing", "0.02em")
          .text(d => {
            const n = normName(d.properties.name || d.id);
            if (!n) return "";
            if (n === "FCT") return "FCT";
            return n.length > 9 ? n.substring(0, 8) + "." : n;
          });

        /* ── Major market pins ── */
        const mkG = svg.append("g");
        MAJORS.forEach(m => {
          const [mx, my] = proj([m.lng, m.lat]);
          if (!mx || !my) return;
          const g = mkG.append("g").style("cursor", "pointer")
            .on("click", () => {
              setSelectedState(m.state);
              setDetailView("state");
              setSelectedMarketIdx(null);
              /* Use ref so the latest callback is always called */
              if (onStateClickRef.current) onStateClickRef.current(m.state);
            });
          g.append("circle").attr("cx", mx).attr("cy", my).attr("r", 16)
            .attr("fill", "none").attr("stroke", "#f59e0b").attr("stroke-width", 1.5).attr("opacity", .3);
          g.append("circle").attr("cx", mx).attr("cy", my - 3).attr("r", 7)
            .attr("fill", "#f59e0b").attr("opacity", .95);
          g.append("path")
            .attr("d", `M${mx - 6},${my - 3} A6,6 0 0,1 ${mx + 6},${my - 3} L${mx},${my + 8} Z`)
            .attr("fill", "#f59e0b").attr("opacity", .9);
          g.append("text").attr("x", mx + 16).attr("y", my + 6)
            .attr("font-size", "10.5")
            .attr("font-weight", "700")
            .attr("fill", "#7c3300")
            .attr("stroke", "rgba(255,255,255,0.9)")
            .attr("stroke-width", "3")
            .attr("paint-order", "stroke")
            .attr("font-family", "Syne, sans-serif")
            .text(m.name);
        });

        setLegendItems([
          { label: "High index (> ₦900)", color: "#45b094" },
          { label: "Mid index (₦600–900)", color: "#9fd9c5" },
          { label: "Low index (< ₦600)",  color: "#e8f4f0" },
        ]);

        if (userCoordsRef.current) {
          drawUserPin(svgEl, proj, userCoordsRef.current.lat, userCoordsRef.current.lng);
        }

      } catch (e) {
        d3.select(svgRef.current).append("text").attr("x", 320).attr("y", 280).attr("text-anchor", "middle")
          .attr("fill", "#94a3b8").attr("font-size", 12).text("Map could not load — check network.");
      }
    }

    loadAndRender();
  }, []);

  function loadScript(src) {
    return new Promise((res, rej) => {
      if (document.querySelector(`script[src="${src}"]`)) { res(); return; }
      const s = document.createElement("script");
      s.src = src; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function highlightState(n) {
    if (!window.d3 || !svgRef.current) return;
    const d3 = window.d3;
    const clr = ["#e8f4f0","#c5e8dc","#9fd9c5","#72c5ad","#45b094","#2a9a7a","#1a7f62","#0f654d","#064e3b"];
    const scale = d3.scaleQuantize([400, 1300], clr);
    d3.select(svgRef.current).selectAll(".state-path")
      .attr("stroke", "#ffffff").attr("stroke-width", 1.2)
      .attr("fill", d => {
        const nn = normName(d.properties?.name || d.id);
        if (nn === n) return "#bae6fd";
        const ss = DATA[nn];
        return ss ? scale(ss.avg) : "#e8f4f0";
      });
    d3.select(svgRef.current).selectAll(".state-path")
      .filter(d => normName(d.properties?.name || d.id) === n)
      .attr("stroke", "#0f766e")
      .attr("stroke-width", 2.5);
  }

  function locateUser() {
    setLocText("Locating...");
    if (!navigator.geolocation) { setLocText("Location unavailable"); return; }
    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude: lat, longitude: lng } = pos.coords;
        userCoordsRef.current = { lat, lng };
        if (projRef.current && svgRef.current) {
          drawUserPin(svgRef.current, projRef.current, lat, lng);
        }
        fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`)
          .then(r => r.json())
          .then(data => {
            const raw = data?.address?.state || data?.address?.county;
            if (raw) {
              const n = normName(raw);
              if (n && DATA[n]) {
                setLocatedState(n);
                setSelectedState(n);
                setDetailView("state");
                setLocText(n);
                highlightState(n);
                if (projRef.current && svgRef.current) {
                  setTimeout(() => drawUserPin(svgRef.current, projRef.current, lat, lng), 30);
                }
              } else {
                setLocText("Located");
              }
            } else {
              setLocText("Located");
            }
          })
          .catch(() => { setLocText("Located"); });
      },
      () => {
        setLocText("Rivers (default)");
        setLocatedState("Rivers");
        setSelectedState("Rivers");
        setDetailView("state");
        userCoordsRef.current = { lat: 4.8156, lng: 7.0498 };
        if (projRef.current && svgRef.current) {
          highlightState("Rivers");
          setTimeout(() => drawUserPin(svgRef.current, projRef.current, 4.8156, 7.0498), 30);
        }
      }
    );
  }

  return (
    <div style={{
      background: "#fff",
      borderRadius: 20,
      border: "1px solid var(--slate-200, #e2e8f0)",
      fontFamily: "var(--font-body, sans-serif)",
      color: "var(--color-text-primary, #1e293b)",
      overflow: "hidden",
    }}>

      {/* ══ Map header — Nigerian flag as background image ══
          The flag image sits behind a semi-transparent white overlay
          so all text and the locate button remain fully readable.
          Nothing else in this header has changed.                   */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 20px 12px",
        gap: 12,
        /* Nigerian flag image + white overlay for readability */
        background: [
          "linear-gradient(rgba(255,255,255,0.78), rgba(255,255,255,0.84))",
          "url('https://upload.wikimedia.org/wikipedia/commons/7/79/Flag_of_Nigeria.svg') center / cover no-repeat",
        ].join(", "),
        borderBottom: "1px solid rgba(148,163,184,0.18)",
        flexWrap: "wrap",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#22c55e", display: "inline-block", flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 14, fontWeight: 600 }}>Nigeria Agricultural Price Map</div>
            <div style={{ fontSize: 11, color: "#64748b", marginTop: 1 }}>
              {selectedState
                ? `Showing prices for ${selectedState} — click another state to switch`
                : "Click any state · auto-locating you"}
            </div>
          </div>
        </div>
        <button
          onClick={locateUser}
          onPointerDown={triggerRipple}
          className="ripple-host"
          style={{ display: "inline-flex", alignItems: "center", gap: 7, background: "linear-gradient(135deg, rgba(236,253,245,1), rgba(220,231,255,1))", border: "1px solid rgba(59,130,246,0.18)", borderRadius: 999, padding: "8px 14px", fontSize: 12, fontWeight: 700, color: "#1e293b", cursor: "pointer", transition: "transform .15s, box-shadow .15s" }}
          onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = "0 10px 24px rgba(15,23,42,0.08)"; }}
          onMouseLeave={e => { e.currentTarget.style.transform = "none"; e.currentTarget.style.boxShadow = "none"; }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0f766e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span>{locText}</span>
        </button>
      </div>

      {/* SVG map canvas — this is the D3 drawing surface */}
      <div id="map-wrap" style={{ position: "relative", width: "100%", minHeight: 340, background: "#fff", overflow: "hidden" }}>
        {tooltip && (
          <div style={{
            position: "absolute",
            left: Math.min(tooltip.x + 28, tooltip.wrapW - 200),
            top: Math.max(8, tooltip.y - 28),
            background: "#fff",
            border: "1px solid rgba(148,163,184,0.24)",
            borderRadius: 12,
            padding: "10px 14px",
            fontSize: 12,
            minWidth: 175,
            zIndex: 20,
            boxShadow: "0 12px 36px rgba(15,23,42,0.1)",
            pointerEvents: "none",
          }}>
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 4, color: "#1e293b" }}>{tooltip.name}</div>
            {tooltip.s ? (
              <>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, color: "#64748b", marginTop: 2 }}>
                  <span>Top item</span><span style={{ color: "#1e293b", fontWeight: 700 }}>{tooltip.s.item}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, color: "#64748b", marginTop: 2 }}>
                  <span>Market index</span><span style={{ color: "#1e293b", fontWeight: 700 }}>{fmt(tooltip.s.avg)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10, color: "#64748b", marginTop: 2 }}>
                  <span>Trend</span><TrendBadge t={tooltip.s.trend} />
                </div>
                <div style={{ marginTop: 6, fontSize: 10, color: "#94a3b8" }}>Click to see local prices</div>
              </>
            ) : (
              <div style={{ color: "#94a3b8" }}>No data available</div>
            )}
          </div>
        )}
        {/* ↓ This SVG is an empty canvas. D3 selects it via svgRef and
              draws every Nigerian state as <path> elements inside it.    */}
        <svg
          ref={svgRef}
          id="map-svg"
          viewBox="0 0 640 520"
          style={{ display: "block", width: "100%", minHeight: 420, background: "#fff" }}
        />
      </div>

      {/* Legend */}
      {legendItems.length > 0 && (
        <div style={{ display: "flex", gap: 12, padding: "8px 18px", borderTop: "0.5px solid #e2e8f0", flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 10, color: "#94a3b8", textTransform: "uppercase", letterSpacing: ".05em", fontWeight: 600 }}>Index scale</span>
          {legendItems.map((l, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#64748b" }}>
              <div style={{ width: 11, height: 11, borderRadius: 2, background: l.color, border: "1px solid rgba(0,0,0,0.1)", flexShrink: 0 }} />
              <span>{l.label}</span>
            </div>
          ))}
          <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#64748b", marginLeft: 4 }}>
            <svg width="10" height="13" viewBox="0 0 10 13">
              <circle cx="5" cy="4" r="3.5" fill="none" stroke="#f59e0b" strokeWidth="1.5" />
              <polygon points="1.5,4 8.5,4 5,12" fill="#f59e0b" opacity=".9" />
            </svg>
            <span>Major market</span>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 10, color: "#0369a1", fontWeight: 600, marginLeft: 4 }}>
            <svg width="11" height="11" viewBox="0 0 11 11">
              <circle cx="5.5" cy="5.5" r="5" fill="rgba(14,165,233,0.2)" stroke="rgba(14,165,233,0.5)" strokeWidth="1" />
              <circle cx="5.5" cy="5.5" r="3" fill="#0ea5e9" stroke="#fff" strokeWidth="1.5" />
            </svg>
            <span>Your location</span>
          </div>
        </div>
      )}

      {/* Price boards */}
      <PriceBoards stateName={selectedState} isLocated={selectedState === locatedState && locatedState !== null} />

      {/* Detail panel */}
      <DetailPanel
        view={detailView}
        stateName={selectedState}
        marketIdx={selectedMarketIdx}
        onReset={() => { setDetailView("empty"); setSelectedState(null); setSelectedMarketIdx(null); }}
        onBack={() => { setDetailView("state"); setSelectedMarketIdx(null); }}
        onSelectMarket={idx => { setSelectedMarketIdx(idx); setDetailView("market"); }}
        onPredictClick={onPredictClick}
      />
    </div>
  );
}